import { Popup } from '@approvalmax/ui/src/components';
import { useAtom } from 'jotai';
import { memo } from 'react';

import { ConnectBankAccountPopupContent } from './components';
import { connectBankAccountPopupOpenState } from './ConnectBankAccountPopup.states';

export const ConnectBankAccountPopup = memo(() => {
    const [open, toggleOpen] = useAtom(connectBankAccountPopupOpenState);

    return (
        <Popup className='fs-exclude' size='small' open={open} onToggle={toggleOpen}>
            <ConnectBankAccountPopupContent />
        </Popup>
    );
});
